import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ITCIApplication, TCIApplicationDeploymentMode } from "@tci/common";

@Component({
    selector: "ng-app-detail-panel-deployment",
    templateUrl: "./ng-app-panel-deployment.html",
    styleUrls: ["./ng-app-panel-deployment.less"]
})
export class NgAppPanelDeploymentComponent implements OnInit {
    @Input() app: ITCIApplication;
    @Output() scaleUpdating: EventEmitter<boolean> = new EventEmitter();

    appDeployMode = TCIApplicationDeploymentMode.MODE_APP_DETAILS;

    constructor() {
    }

    ngOnInit(): void {
    }
}
